// @ts-nocheck

export const GRRoutesActionTypes = Object.freeze({
  OPEN_GR_VIEW: 'GIFT_RACE:OPEN_MAIN_VIEW',
});
